import initialState from './initialState';
import {ROOMMAP_FETCH, ROOMMAP_RECEIVE, ROOMMAP_APIERROR, ROOMMAP_ISLOADING} from '../actions/actionTypes';

export function roomMap(state = initialState.roomMap, action) {

  switch (action.type) {
    case ROOMMAP_FETCH:
      console.log('ROOMMAP_FETCH Action')
      return action;
      
    case ROOMMAP_RECEIVE:
      console.log('ROOMMAP_RECEIVE Action')
      return action.roomMap;

      default:
      return state;
  }
}

export function roomMapHasErrored(state = false, action) {
  switch (action.type) {
    case ROOMMAP_APIERROR:
      console.log('ROOMMAP_APIERROR Action')
      return {hasErrored: action.hasErrored, errMsg: action.errMsg};

    default:
          return state;
  }
}

export function roomMapIsLoading(state = false, action) {
  switch (action.type) {
    case ROOMMAP_ISLOADING:
      console.log('ROOMMAP_ISLOADING Action')
      return action.isLoading;

      default:
          return state;
  }
}